import React, { useEffect } from "react";
import Storage from "../services/storage.service";
import ClosingBillSummary from "../views/simDeactivation/sim-deactivation-closing-summary";
import SimDeactivationStepper from "../views/simDeactivation/stepper";

export default function SimDeactivationSummaryUI(props) {
	useEffect(() => {
        const stepsDetails = {
            step1: {
                // Number
                // Prepaid & Postpaid
              status: "isDone",
            },
            step2: {
                // OTP
                // Postpaid Only
              status: "isDone",
            },
            step3: {
                // Absher
                // PrePaid Only
              status: "isDone",
            },
            step4: {
                // Payment
                // Postpaid Only
              status: "inProgress",
            },
            step5: {
                // Confirmation
                // Prepaid & Postpaid
              status: "notVisited",
            }
        };
        Storage.set("act_step_detail", stepsDetails)
    }, [])

	return (
		<div className="storefront-two-col-pg">
            <div className="sim-deactivation-otp">
                <ClosingBillSummary {...props}/>
            </div>
			<SimDeactivationStepper />
		</div>
	)
}